import {
     CREATEOPDCHARGE,
     DELETEOPDCHARGE, 
     GETOPDCHARGE, 
     UPDATEOPDCHARGE
 } from '../actions/types';

const initialState = {
}

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {

    switch (action.type) {
        case CREATEOPDCHARGE:
            return {
                ...state,
                opdchargeSaveStatus: action.payload.success,
            }
        case GETOPDCHARGE:
                return {
                        ...state,
                        opdchargeList: action.payload.data,
                        }
        case UPDATEOPDCHARGE:
                return {
                        ...state,
                        opdchargeUpdateStatus: action.payload.success,
                        }   

        case DELETEOPDCHARGE:
                 return {
                     ...state,
                     opdchargeDeleteStatus: action.payload.success,
                        } 
                        default:
                            return state
                             }
                         }